var $33670e148c84ad02$exports = {};
$33670e148c84ad02$exports = {
    "removeButtonLabel": `Ta bort`,
    "removeDescription": `Tryck p\xe5 Radera f\xf6r att ta bort taggen.`
};


export {$33670e148c84ad02$exports as default};
//# sourceMappingURL=sv-SE.module.js.map
